import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Oregon = () => {
  return (
    <StatePropertyTaxPage
      stateName="Oregon"
      processDescription="Property owners may appeal their assessment by filing with the county board of property tax appeals within 30 days of receiving notice. Appeals should include evidence supporting the property owner's claimed real market value."
      noticeOfValueMailed="October"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in October with the property tax statements."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Oregon assesses property as of January 1 each year. This assessment date captures the property's real market value at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners have 30 days from receiving the assessment notice to file appeals. This typically results in a November deadline, though the exact date depends on when notices are mailed."
    />
  );
};

export default Oregon;